import { createContext, useContext, useEffect, useState } from "react";
import { onAuth } from "../firebase/services";
import { db } from "../firebase/config";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuth(async (firebaseUser) => {
      if (firebaseUser) {
        setUser(firebaseUser);
        try {
          const snap = await getDoc(doc(db, "users", firebaseUser.uid));
          if (snap.exists()) {
            const d = snap.data();
            setProfile({
              role:   d.role   || null,
              name:   d.name   || "",
              email:  d.email  || firebaseUser.email || "",
              roomId: d.roomId || null,
            });
          } else {
            setProfile(null);
          }
        } catch (err) {
          console.error("Erreur chargement profil:", err);
          setProfile(null);
        }
      } else {
        setUser(null);
        setProfile(null);
      }
      setLoading(false);
    });
    return unsub;
  }, []);

  return (
    <AuthContext.Provider value={{ user, profile, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
